module.exports = __webpack_public_path__ + "static/img/10.3667574.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/10.png
// module id = wCzO
// module chunks = 0